import Accordion from "../misc/accordion.tsx";
import { RoundedButton } from "../button";
import Typography from "../misc/typography.tsx";
import TopHeader from "../misc/topHeader.tsx";

export default function FaqSection() {
  const faqItems = [
    {
      title: "What is Rumble?",
      description:
        "Rumble is an NFT-based knockout tournament game where players mint and battle with elemental warriors (Fire, Water, Earth, and Air). Each element has unique strengths and abilities that affect battle strategies. Players can compete for substantial prize pools and earn exclusive rewards.",
    },
    {
      title: "How do I get started?",
      description:
        "To start playing Rumble: 1) Connect your wallet, 2) Mint your elemental warrior during the mint window (22/11/24 at 7pm UTC), 3) Enter the arena to start battling. The mint price is 0.5 SOL and the total supply is 5000 warriors.",
    },
    {
      title: "How do battles work?",
      description:
        "Battles are conducted in a tournament format using advanced algorithms that consider elemental advantages, character stats, and strategic decisions. Each round, winners can either split the prize pool or continue fighting to become the last warrior standing.",
    },
    {
      title: "What are the different elements and their advantages?",
      description:
        "There are four elements: Fire (high attack, aggressive style), Water (balanced stats, adaptable), Earth (high defense, endurance-focused), and Air (high speed, evasive). Each element has unique abilities and advantages against certain elements in battle.",
    },
    {
      title: "What rewards can I earn?",
      description:
        "Players can earn: 1) Prize pool shares from tournament victories, 2) Exclusive NFT rewards for achievements, 3) Special character skins, 4) Access to additional battle arenas, and 5) Seasonal tournament rewards.",
    },
    {
      title: "What features are coming in the full release?",
      description:
        "The full release will include: Ranked matchmaking, seasonal tournaments, guild wars, enhanced battle mechanics, multiple battle arenas, and exclusive NFT rewards. We're constantly developing new features based on community feedback.",
    },
    {
      title: "How can I join the whitelist?",
      description:
        "To join the whitelist, visit our whitelist page and submit your details including Discord username and email. Whitelist members get priority access to minting and special community benefits.",
    },
    {
      title: "Is there a community I can join?",
      description:
        "Yes! Join our vibrant community on Discord and Twitter to connect with other players, get game updates, participate in events, and provide feedback. Our community plays a crucial role in shaping the game's future.",
    }
  ];

  return (
    <div
      className="min-h-screen text-white px-8 py-16 font-sans relative overflow-hidden"
      id={"how-it-works"}
    >
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,rgba(99,102,241,0.15),rgba(0,0,0,0)_70%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_60%,rgba(245,158,11,0.1),rgba(0,0,0,0)_50%)]" />

      <div className={"container relative z-10"}>
        <TopHeader title={"Clarity from the Depths"} />
      </div>
      <div className="container relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <Typography>FAQ</Typography>
        </div>

        <div className="flex flex-col lg:flex-row w-full lg:items-center justify-between gap-2 border-b-2 pb-[1em] mb-12">
          <h3 className={"code-mono text-3xl"}>Clarity From Depths</h3>
        </div>

        {/* Description */}
        <div className="mb-12">
          <p className="text-gray-400 text-sm lg:text-lg leading-relaxed md:w-[500px] code-mono">
            Find answers to the most common questions about Rumble - from getting started
            to advanced gameplay mechanics.
          </p>
        </div>

        {/* Questions */}
        <div className="space-y-8">
          {faqItems.map((item, index) => (
            <Accordion
              key={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
